import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

const STATUS_STYLES = {
  AKTIF: { className: 'bg-green-100 text-green-800', icon: CheckCircle },
  'TAMAT TEMPOH': { className: 'bg-red-100 text-red-800', icon: XCircle },
};

const DEFAULT_STYLE = { className: 'bg-yellow-100 text-yellow-800', icon: XCircle };

export const StatusBadge = ({ status }) => {
  const { className, icon: Icon } = STATUS_STYLES[status] || DEFAULT_STYLE;
  return (
    <span
      data-testid="license-status-badge"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${className}`}
    >
      <Icon size={12} />
      {status}
    </span>
  );
};

export default StatusBadge;
